import {Component, EventEmitter, input, InputSignal, Output} from '@angular/core';
import {CellEditorComponent} from '../cell-editor/cell-editor.component';
import {ICellChangedEvent} from '../cell-editor/cell-changed-event.interface';
import {ITableVerticalDataGroup} from '../table-vertical-api-adapter';
import {IControlDataChanged} from '../../../../../../../nucleus/src/lib/apiv2/control.store';

@Component({
  selector: 'lib-table-vertical-control-core',
  standalone: true,
  imports: [CellEditorComponent],
  templateUrl: './table-vertical-control-core.component.html',
  styleUrl: './table-vertical-control-core.component.scss'
})
export class TableVerticalControlCoreComponent {
  groups: InputSignal<ITableVerticalDataGroup[]> = input<ITableVerticalDataGroup[]>();
  showImports: InputSignal<boolean> = input<boolean>(false);

  @Output() cellChanged: EventEmitter<{ row: ICellChangedEvent, groupIdx: number}> = new EventEmitter<{
    row: ICellChangedEvent,
    groupIdx: number,
  }>();
  @Output() updateTable: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectionDataChange: EventEmitter<IControlDataChanged> = new EventEmitter<IControlDataChanged>();

  onCellChange(evt: ICellChangedEvent, groupIdx: number): void {
    this.cellChanged.emit({row: evt, groupIdx});
  }

  onUpdateTable(): void {
    this.updateTable.emit();
  }

  onSelectionDataChange(evt: IControlDataChanged): void {
    this.selectionDataChange.emit(evt);
  }
}
